/**
 * Converts SFCC CMS HTML export attributes to JSX/React equivalents before parsing.
 * CMS export uses static HTML (`class`, `checked`, `for`); react-jsx-parser expects JSX.
 */
export function normalizeCmsReactMarkup(content: string): string {
    return content.replaceAll(/<input\b([^>]*?)(\s*\/?)>(?:<\/input>)?/gi, (match, attrs: string) => {
        if (!/\bchecked\b/i.test(attrs)) {
            return match;
        }

        const normalizedAttrs = attrs.replaceAll(/\s+checked(?:=(?:""|''|true|false))?\b/gi, '').trim();
        return normalizedAttrs ? `<input ${normalizedAttrs} defaultChecked />` : '<input defaultChecked />';
    });
}
